import { config } from "../../app/env.js";
import { t, type Key } from "../../shared/i18n.js";
import { BackLink } from "../../shared/common.js";

const SECTIONS = ["storage", "retention", "ai", "quotas", "delete"] as const;

/** « Ce qu'on fait de vos vidéos » : accessible sans être connecté (lien depuis la connexion). */
export function Privacy() {
  const contact = config.contactEmail ? ` (${config.contactEmail})` : "";
  return (
    <div className="flow">
      <header className="bar">
        <BackLink to="/" />
        <span className="bar-title">{t("privacy.title")}</span>
        <span className="icon-btn" aria-hidden="true" />
      </header>
      <main className="page narrow privacy">
        <h1>{t("privacy.title")}</h1>
        <p className="muted">{t("privacy.intro")}</p>
        {SECTIONS.map((k) => (
          <section key={k}>
            <h2>{t(`privacy.${k}.title` as Key)}</h2>
            <p className="muted">{t(`privacy.${k}.body` as Key, { contact })}</p>
          </section>
        ))}
      </main>
    </div>
  );
}
